/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */

/** Keep track of how many notifications of each type are happening to avoid
 * hiding the notifier too early */
const _notifierQueue = {};

window.hideAllNotifiers = function hideAllNotifiers() {
  // Register.php contains many parameter updates that should not hide notifications.
  // Workorder_ and register_ are also part of the register flow, navigating to the
  // main register screen from these places should also not hide notifications.
  const reg_pages = /\/register\.php|workorder_|beta_workorder|register_/;

  if (!window.location.href.match(reg_pages)) {
    $(document.querySelectorAll('.alert-warning, .alert-messages')).hide();
  }
};

window.alertUser = function alertUser(msg, time) {
  window.flashNotifier('warning', msg, time || 15);
};

window.warnUser = function warnUser(msg, time) {
  window.flashNotifier('messages', msg, time || 15);
};

/**
 * Show a message of type. Visible on Stencil for griffin_secs seconds.
 * @param {String} type
 * @param {String} message
 * @param {Number} [griffin_secs]
 */
window.showNotifier = function showNotifier(type, message, griffin_secs) {
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (!_notifierQueue[type]) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    _notifierQueue[type] = 1;
  } else {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // eslint-disable-next-line no-plusplus
    _notifierQueue[type]++;
  }

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
  if (!_showNotifierGriffin(type, message, griffin_secs)) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
    _showNotifierDesktop(type, message);
  }
};

/**
 * Hide a message of type after delay_msecs milliseconds.
 * Checks message queue count, and only hides when 0. eg. If you have asked
 * to show "Working" twice, it will remain visible until you hide it twice.
 * @param {String} type
 * @param {Number} delay_msecs
 */
window.hideNotifier = function hideNotifier(type, delay_msecs) {
  // Only hide if we have 0 remaining notifications waiting of this type
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (_notifierQueue[type] && _notifierQueue[type] > 0) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // eslint-disable-next-line no-plusplus
    _notifierQueue[type]--;
  }

  // Hide desktop notifications
  switch (type) {
    case 'working':
    case 'success':
      setTimeout(() => {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        if (!_notifierQueue[type]) {
          // Hide
          // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
          $(document.getElementById(type))
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'removeClass' does not exist on type 'JQu... Remove this comment to see the full error message
            .removeClass('active')
            // And remove message
            .find('a span')
            .html('');
        }
      }, delay_msecs);
      break;
    default:
      // Remove alert-offset class after fading out.
      const $alert = $(`.alert-${type}`).filter(':visible');
      setTimeout(() => {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        if (!_notifierQueue[type]) {
          $alert.fadeOut(() => $alert.removeClass('alert-offset'));
        }
      }, delay_msecs || 0);
  }

  // Hide Stencil notifications.
  if (window.isGriffin()) {
    window.StencilWebAPI.navigation.setBusyState(false);
  }
};

/**
 * Display a message for show_secs seconds.
 * @param {String} type
 * @param {String} message
 * @param {Number} show_secs
 */
window.flashNotifier = function flashNotifier(type, message, show_secs) {
  switch (type) {
    case 'warning':
      window.merchantos.notifier.cancelWarningTimeout();
      break;
    case 'messages':
      window.merchantos.notifier.cancelAlertTimeout();
      break;
    default:
    // swallow
  }

  window.showNotifier(type, message, show_secs);
  // remove html tags from message text
  const data_message = (typeof message === 'string' ? message : '').replace(/<(?:.|\n)*?>/gm, '');
  $('body').data(data_message, true);
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  window.hideNotifier(type, show_secs * 1000);
};

class Notifier implements MerchantosNotifier {
  warning_timeout: number;

  alert_timeout: number;

  warning_clear_count: number;

  alert_clear_count: number;

  constructor() {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'undefined' is not assignable to type 'number... Remove this comment to see the full error message
    this.warning_timeout = undefined;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'undefined' is not assignable to type 'number... Remove this comment to see the full error message
    this.alert_timeout = undefined;
    this.warning_clear_count = 0;
    this.alert_clear_count = 0;
  }

  startWarningTimeout = () => {
    if (this.warning_timeout) return;
    if (this.warning_clear_count < 4) {
      // eslint-disable-next-line no-plusplus
      this.warning_clear_count++;
      return;
    }
    this.warning_clear_count = 0;
    this.warning_timeout = window.setTimeout(
      () => window.merchantos.notifier.fireWarningTimeout(),
      3000
    );
  };

  cancelWarningTimeout = () => {
    this.warning_clear_count = 0;
    if (!this.warning_timeout) return;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'undefined' is not assignable to type 'number... Remove this comment to see the full error message
    this.warning_timeout = undefined;
    clearTimeout(this.warning_timeout);
  };

  fireWarningTimeout = () => {
    if (!this.warning_timeout) return;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'undefined' is not assignable to type 'number... Remove this comment to see the full error message
    this.warning_timeout = undefined;
    $('.alert-warning').hide();
  };

  startAlertTimeout = () => {
    if (this.alert_timeout) return;
    if (this.alert_clear_count < 4) {
      // eslint-disable-next-line no-plusplus
      this.alert_clear_count++;
      return;
    }
    this.alert_timeout = window.setTimeout(
      () => window.merchantos.notifier.fireAlertTimeout(),
      3000
    );
  };

  cancelAlertTimeout = () => {
    this.alert_clear_count = 0;
    if (!this.alert_timeout) return;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'undefined' is not assignable to type 'number... Remove this comment to see the full error message
    this.alert_timeout = undefined;
    clearTimeout(this.alert_timeout);
  };

  fireAlertTimeout = () => {
    if (!this.alert_timeout) return;
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'undefined' is not assignable to type 'number... Remove this comment to see the full error message
    this.alert_timeout = undefined;
    $('.alert-messages').hide();
  };
}

/**
 * Notifier alerts & warnings
 */
window.merchantos.notifier = new Notifier();

// PRIVATE

/**
 * Set the Stencil busy state.
 * @param {String} type
 * @param {String} message
 * @param {Number} [delaysecs]
 * @return boolean
 * @private
 */
const _showNotifierGriffin = (type: NotifierType, message: string, delaysecs?: number) => {
  if (window.isGriffin()) {
    switch (type) {
      case 'working': {
        window.StencilWebAPI.navigation.setBusyState(true);
        return true;
      }
      case 'success': {
        const sanitizedMessage = $(`<div>${message}</div>`).text();
        const notify = {
          message: sanitizedMessage,
          type,
          duration: delaysecs,
        };
        window.StencilWebAPI.notifier.showStencilNotification(notify);
        return true;
      }
      default: {
        // swallow
      }
    }
  }
  return false;
};

/**
 * Show messages in the DOM.
 * @param {String} type
 * @param {String} message
 * @private
 */
const _showNotifierDesktop = (type: NotifierType, message: string) => {
  if (type === 'working' || type === 'success') {
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    const $type = $(document.getElementById(type));
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'find' does not exist on type 'JQueryStat... Remove this comment to see the full error message
    const $spans = $type.find('a span');

    if (message && String(message).length > 0) {
      $spans.html(message);
    } else {
      // Use type as message
      $spans.html(type.charAt(0).toUpperCase() + type.slice(1));
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'addClass' does not exist on type 'JQuery... Remove this comment to see the full error message
    $type.addClass('active');
  } else {
    if (type === 'warning') {
      window.merchantos.notifier.cancelWarningTimeout();
    }
    if (type === 'messages') {
      window.merchantos.notifier.cancelAlertTimeout();
    }

    // When it's a back-end error, a filename.ext will be present in the
    // message, we don't want those to be translated
    if (/[^\s]+\.(php|tpl)/.test(message)) {
      // eslint-disable-next-line no-param-reassign
      message = `<span notranslate>${message}</span>`;
    }

    $(document.querySelectorAll(`.alert-${type}_inner`)).html(message);

    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    $(document.getElementById('wrapper'))
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'find' does not exist on type 'JQueryStat... Remove this comment to see the full error message
      .find(`.alert-${type}`)
      .css('display', '');
  }
};
